import { render } from "./DynamicChartBar.vue?vue&type=template&id=40eca00c&ts=true"
import script from "./DynamicChartBar.vue?vue&type=script&lang=ts"
export * from "./DynamicChartBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicChartBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40eca00c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40eca00c', __exports__)) {
    api.reload('40eca00c', __exports__)
  }
  
  module.hot.accept("./DynamicChartBar.vue?vue&type=template&id=40eca00c&ts=true", () => {
    api.rerender('40eca00c', render)
  })

}


export default __exports__